"use strict";
function findIndex(array, cb) {
    var index = -1;
    for (var i = 0; array && i < array.length; i++) {
        if (cb(array[i], i)) {
            index = i;
            break;
        }
    }
    return index;
}
exports.findIndex = findIndex;
function createArray(size, getItem) {
    var array = [];
    for (var i = 0; i < size; i++) {
        array.push(getItem(i));
    }
    return array;
}
exports.createArray = createArray;

//# sourceMappingURL=array.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./utilities/array.js
 ** module id = 14
 ** module chunks = 0
 **/